import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap'

import ShareButton from './ShareButton'
import SlideHOC from '../SlideHOC'
import ANIMATION_TYPES from '../../../../constants/animationTypes'
import PlayStoreIcon from '../../assets/playstore.svg'
import AppleStoreIcon from '../../assets/appstore.svg'
import './LastScene.scss'

class LastScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.bgRef, this.props.duration * 0.95,
        { xPercent: 110 }, { xPercent: 0, delay: this.props.duration * 0.05 })
      .fromTo([this.contentRef, this.shareButtonRef], this.props.duration * 0.25,
        { autoAlpha: 0 }, { autoAlpha: 1, delay: this.props.duration * 0.75 }, 0)

    this.inReversedAnimation = this.inAnimation

    this.outReversedAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration, { xPercent: 0, autoAlpha: 1, immediateRender: false }, { xPercent: 110 })

    this.outAnimation = this.outReversedAnimation
  }

  onClick = () => {
    if (this.props.buttonUrl) {
      window.location.href = this.props.buttonUrl
    }
  }

  goToUrl (url) {
    // console.log('go to url', url)
    if (url) {
      window.location.href = url
    }
  }


  renderFieldTypeContent = () => {
    const { button, buttonFieldType, appLinks } = this.props
    switch (buttonFieldType) {
      case 'button':
        return (
          <div id='aw_last__button' className='aw_last__button' onClick={this.onClick}>{ button }</div>
        )
      case 'appLinks':
        return (
          <div id='aw_last__applinks-container' className='aw_last__applinks-container'>
            {appLinks && appLinks['google'] &&
              <div
                id={`aw_last__applinks--button-1`}
                className={`aw_slide__tip--applink aw_last__applinks--button-1`}
                style={{backgroundImage: `url(${PlayStoreIcon})`}}
                onClick={e => this.goToUrl(appLinks['google'])}
              />
            }
            {appLinks && appLinks['apple'] &&
              <div
                id={`aw_last__applinks--button-2`}
                className={`aw_slide__tip--applink aw_last__applinks--button-2`}
                style={{backgroundImage: `url(${AppleStoreIcon})`}}
                onClick={e => this.goToUrl(appLinks['apple'])}
              />
            }
          </div>
        )
      default:
        return (
          <div id='aw_last__button' className='aw_last__button' onClick={this.onClick}>{ button }</div>
        )
    }
  }

  render () {
    const { title, description, bg, facebook, twitter, email, phone, shareTitle, shareSubtitle, setShareButtonsVisible } = this.props
    return (
      <div className='aw_last' ref={ref => (this.rootRef = ref)}>
        <div className='aw_last__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <div
            id='aw_last__bg'
            className='aw_last__bg'
            style={{ backgroundImage: `url(${bg})` }}
            ref={ref => (this.bgRef = ref)}
          />

          <div className='aw_last__content' ref={ref => (this.contentRef = ref)}>
            <div id='aw_last__title' className='aw_last__title'>{ title }</div>
            <div className='aw_last__divider' />
            <div id='aw_last__description' className='aw_last__description'><span className='aw_last__description--text'>{ description }</span></div>
            {this.renderFieldTypeContent()}
          </div>
          <div ref={ref => (this.shareButtonRef = ref)}>
            <ShareButton
              facebook={facebook}
              twitter={twitter}
              email={email}
              phone={phone}
              shareTitle={shareTitle}
              shareSubtitle={shareSubtitle}
              setShareButtonsVisible={setShareButtonsVisible}
            />
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 1
  }

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    bg: PropTypes.string,
    button: PropTypes.string,
    buttonUrl: PropTypes.string,
    facebook: PropTypes.string,
    buttonFieldType: PropTypes.string,
    appLinks: PropTypes.object,
    twitter: PropTypes.string,
    email: PropTypes.string,
    shareTitle: PropTypes.string,
    shareSubtitle: PropTypes.string,
    phone: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
    setShareButtonsVisible: PropTypes.func
  }
}

export default SlideHOC(LastScene)



// WEBPACK FOOTER //
// ./src/templates/app-website/components/last/LastScene.js